import axios from "axios";
import { camelizeKeys, decamelizeKeys } from "humps";
import { toast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";

export const api = axios.create({
  baseURL:
    import.meta.env.VITE_BASE_URL ??
    "https://manufacture-app-226132502022.asia-east1.run.app", //curretnly for lovable to have be
});

api.interceptors.request.use(async (config) => {
  // Don't process FormData objects
  if (config.data && !(config.data instanceof FormData)) {
    config.data = decamelizeKeys(config.data);
  }
  if (config.params) config.params = decamelizeKeys(config.params);

  const { data, error } = await supabase.auth.getSession();
  if (!error && data.session?.access_token) {
    config.headers.Authorization = `Bearer ${data.session.access_token}`;
  }

  return config;
});

api.interceptors.response.use(
  (res) => {
    res.data = camelizeKeys(res.data);
    return res;
  },
  (err) => {
    if (err.response?.data) err.response.data = camelizeKeys(err.response.data);

    let description = "Unexpected error";
    const errorDetail = err.response?.data?.detail;
    const errorMessage = err.response?.data?.message;
    
    if (errorDetail) {
      if (typeof errorDetail === 'string') {
        description = errorDetail;
      } else if (Array.isArray(errorDetail)) {
        description = errorDetail.map(err => err.msg || err).join(', ');
      } else if (typeof errorDetail === 'object') {
        description = JSON.stringify(errorDetail);
      }
    } else if (errorMessage) {
      description = errorMessage;
    } else if (err.message) {
      description = err.message;
    }

    toast({
      title: `Error`,
      description,
      variant: "destructive",
    });

    return Promise.reject(err);
  }
);
